import React from "react";
import { StateContext } from "../../KioskContext";
import { KioskStateType } from "../../KioskReducer";

export function useKioskState() : KioskStateType {
	const context = React.useContext(StateContext);
	if (context === undefined) {
		throw new Error('useKioskState must be used within a KioskProvider');
	}

	return context;
}